var path = './migrate-home-drive/title_bar.html';
var html = "<div role=\"menu\" class=\"menu\" style=\"margin: 0px 0px;\" ng-if=\"authenticated\">\n    <div class=\"menu-row\">\n        <secondary-nav path=\"path\"></secondary-nav>\n    </div> \n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;